import { lazyWithPreload, createComponentRegistry } from 'copilot-toolkit/js/custom-components';
const TYPES = {
  MARKETPLACE_BA_CARD_SMALL: 'MARKETPLACE_BA_CARD_SMALL'
};
const MarketplaceCardSmallComponent = lazyWithPreload(() => import( /* webpackChunkName: "marketplace-embed-ba" */'./custom-components/MarketplaceCardSmallComponent'));
export const marketplaceInstallRegistry = createComponentRegistry('MARKETPLACE_BA', {
  MARKETPLACE_BA_CARD_SMALL: MarketplaceCardSmallComponent
});
export { TYPES as MARKETPLACE_BA_TYPES };